import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Avatar,
  Stack,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import DownloadIcon from '@mui/icons-material/Download';

import TopNav from './Navbar';
import LeftNavbar from './LeftNav';
import Breadcrumb from './BreadCrump';

const API_BASE = 'http://196.216.9.34:5020/api/certificates'; // <-- adjust endpoint

const Certificates = () => {
  const [certificates, setCertificates] = useState([]);
  const token = localStorage.getItem('token');

  const fetchCertificates = async () => {
    if (!token) return;
    try {
      const response = await fetch(`${API_BASE}/student-certificates`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error(`Failed to fetch certificates: ${response.status}`);

      const data = await response.json();
      setCertificates(data);
    } catch (error) {
      console.error('Error fetching certificates:', error.message);
    }
  };

  useEffect(() => {
    fetchCertificates();
  }, [token]);

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />

        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Certificates" />
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ mb: 4, color: '#ff6600' }}
          >
            <VerifiedIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Certificates
          </Typography>

          <Grid container spacing={3}>
            {certificates.map((cert) => (
              <Grid item xs={12} sm={6} md={4} key={cert.id}>
                <Card
                  sx={{
                    boxShadow: 3,
                    borderLeft: '6px solid #ff6600',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                      mb={2}
                    >
                      <Avatar sx={{ bgcolor: '#ff6600' }}>
                        <VerifiedIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ fontSize: '1rem' }}>
                          {cert.courseName}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          {cert.issuedBy}
                        </Typography>
                      </Box>
                    </Stack>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Issued:</strong> {new Date(cert.generatedOn).toLocaleDateString()}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      <strong>ID:</strong> {cert.id}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ justifyContent: 'flex-end', pr: 2, pb: 2 }}>

                    {/* View Certificate */}
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<VerifiedIcon />}
                      sx={{
                        borderColor: '#ff6600',
                        color: '#ff6600',
                        '&:hover': { bgcolor: '#fff3e6', borderColor: '#e65c00' },
                      }}
                      onClick={() => window.open(`http://196.216.9.34:5020${cert.fileUrl}`, '_blank')}
                    >
                      View
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      startIcon={<DownloadIcon />}
                      sx={{
                        bgcolor: '#ff6600',
                        '&:hover': { bgcolor: '#e65c00' },
                      }}
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = `http://196.216.9.34:5020${cert.fileUrl}`;  // full URL already returned by backend
                        link.setAttribute('download', `${cert.courseName}-certificate.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                      
                    >
                      Download
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Certificates;
